import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const { t, switchLanguage, language } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // Only apply hide/show on mobile
      if (window.innerWidth <= 768) {
        if (currentScrollY > lastScrollY && currentScrollY > 50) {
          setIsVisible(false);
          setIsMenuOpen(false); // Optionally close menu when hiding
        } else {
          setIsVisible(true);
        }
        setLastScrollY(currentScrollY);
      }
      // ...existing code for active link...
      const sections = document.querySelectorAll('section');
      const navLinks = document.querySelectorAll('.nav-links a');
      let current = '';
      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (window.scrollY >= sectionTop) {
          current = section.getAttribute('id');
        }
      });
      navLinks.forEach((link) => {
        link.classList.remove('active');
        if (current && link.getAttribute('href') === `#${current}`) {
          link.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header
      style={{
        // Only animate on mobile
        transform:
          typeof window !== 'undefined' && window.innerWidth <= 768
            ? isVisible
              ? 'translateY(0)'
              : 'translateY(-100%)'
            : 'none',
        transition: 'transform 0.3s ease-in-out',
      }}
    >
      <nav>
        <a href="#home" className="logo">
          <img src="/images/logo.webp" alt="JKD Logo" className="logo-image" />
          <span className="logo-text">JKD Functional Defense</span>
        </a>
        
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          {/* <li><a href="#home" onClick={closeMenu}>{t.header.home}</a></li> */}
          {/* <li><a href="#about" onClick={closeMenu}>{t.header.about}</a></li> */}
          {/* <li><a href="#mission" onClick={closeMenu}>{t.header.mission}</a></li> */}
          <li><a href="#program" onClick={closeMenu}>{t.header.program}</a></li>
          <li><a href="#instructor" onClick={closeMenu}>{t.header.instructor}</a></li>
          <li><a href="#faq" onClick={closeMenu}>{t.header.faq}</a></li>
          <li><a href="#instagram" onClick={closeMenu}>{t.header.gallery}</a></li>
          <li><a href="#contact" onClick={closeMenu}>{t.header.contact}</a></li>
          
          <li className="language-switcher">
            <button 
              className={language === 'en' ? 'active' : ''} 
              onClick={() => { switchLanguage('en'); closeMenu(); }}
              aria-label="English"
            >
              🇬🇧
            </button>
            <button 
              className={language === 'it' ? 'active' : ''} 
              onClick={() => { switchLanguage('it'); closeMenu(); }}
              aria-label="Italian"
            >
              🇮🇹
            </button>
            <button 
              className={language === 'de' ? 'active' : ''} 
              onClick={() => { switchLanguage('de'); closeMenu(); }}
              aria-label="German"
            >
              🇩🇪
            </button>
          </li>
        </ul>

        <div className="hamburger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>
    </header>
  );
}

export default Header;
